export enum DrawingEventType {
  add,
  remove,
  update
}
